import React, { useEffect, useMemo, useState } from "react";
import "./Header.css";
import {
  FaBars,
  FaTimes,
  FaPhoneAlt,
  FaArrowRight,
} from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { webinfo = {} } = useLocalContext();

  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const phoneRaw = webinfo?.phonecall || webinfo?.phone || "+91 80000 00000";
  const phoneDisplay = webinfo?.phone || phoneRaw;
  const siteName = webinfo?.name || "Your Brand";

  const navItems = useMemo(
    () => [
      { label: "Home", to: "/" },
      { label: "Services", to: "/services" },
      { label: "Solutions", to: "/our-strategies" },
      { label: "About Us", to: "/about" },
      { label: "Our Process", to: "/process" },
      { label: "Contact", to: "/contact" },
    ],
    []
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 14);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const isActive = (to) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className={`hd5 ${scrolled ? "hd5--scrolled" : ""}`}>
      <div className="hd5-shell">
        <div className="hd5-topline">
          <p>Modern Websites • Clear Strategy • Real Results</p>
        </div>

        <div className="hd5-inner">
          <button
            className="hd5-logo"
            onClick={() => navigate("/")}
            aria-label="Go to homepage"
          >
            {webinfo?.logo || webinfo?.logowhite ? (
              <img
                src={webinfo?.logo || webinfo?.logowhite}
                alt={siteName}
              />
            ) : (
              <span className="hd5-logoText">{siteName}</span>
            )}
          </button>

          <nav className="hd5-nav" aria-label="Primary navigation">
            {navItems.map((item) => (
              <button
                key={item.to}
                className={`hd5-link ${isActive(item.to) ? "is-active" : ""}`}
                onClick={() => navigate(item.to)}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="hd5-actions">
            <a className="hd5-call" href={`tel:${phoneRaw}`}>
              <span className="hd5-callIcon">
                <FaPhoneAlt />
              </span>
              <span className="hd5-callText">
                <small>Call us</small>
                <strong>{phoneDisplay}</strong>
              </span>
            </a>

            <button className="hd5-cta" onClick={() => navigate("/contact")}>
              Start Your Project
              <FaArrowRight />
            </button>
          </div>

          <button
            className="hd5-burger"
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            <FaBars />
          </button>
        </div>
      </div>

      <div className={`hd5-drawer ${menuOpen ? "is-open" : ""}`}>
        <button
          className="hd5-backdrop"
          onClick={() => setMenuOpen(false)}
          aria-label="Close menu backdrop"
        />

        <aside className="hd5-panel">
          <div className="hd5-panelTop">
            <div className="hd5-panelBrand">
              {webinfo?.logo || webinfo?.logowhite ? (
                <img
                  src={webinfo?.logo || webinfo?.logowhite}
                  alt={siteName}
                />
              ) : (
                <span className="hd5-logoText">{siteName}</span>
              )}
            </div>

            <button
              className="hd5-close"
              onClick={() => setMenuOpen(false)}
              aria-label="Close menu"
            >
              <FaTimes />
            </button>
          </div>

          <div className="hd5-panelIntro">
            <p>
              Modern websites and digital solutions built to help your business
              look great and grow faster.
            </p>
          </div>

          <nav className="hd5-mnav">
            {navItems.map((item) => (
              <button
                key={item.to}
                className={`hd5-mitem ${isActive(item.to) ? "is-active" : ""}`}
                onClick={() => {
                  setMenuOpen(false);
                  navigate(item.to);
                }}
              >
                <span>{item.label}</span>
                <FaArrowRight />
              </button>
            ))}
          </nav>

          <div className="hd5-mfooter">
            <a className="hd5-mcall" href={`tel:${phoneRaw}`}>
              <FaPhoneAlt />
              <span>{phoneDisplay}</span>
            </a>

            <button
              className="hd5-mprimary"
              onClick={() => {
                setMenuOpen(false);
                navigate("/contact");
              }}
            >
              Get Free Consultation
            </button>
          </div>
        </aside>
      </div>
    </header>
  );
};

export default Header;